import { TnAWorkedTimeTotalsDTO, TnAWorkedTimeTotalsSTO } from "../../models/tna-worked-time-totals";
import { BaseApiService } from "../base/base-api.service";

export class TnAWorkedTimeTotalsApiService extends BaseApiService<TnAWorkedTimeTotalsDTO, TnAWorkedTimeTotalsSTO> {
  constructor() {
    super({
      servicePath: "/TnAOverviews",
      loadItemsPath: "/GetTnAWorkedTimeTotals",
    });
  }
}
